<template>
  <div>
    <header class="page-header">
      <PageTitle/>
    </header>

    <div class="main-content">
      <div class="pane table-pane" :class="{'loading': isLoading}">
        <formulate-form @submit="submitForm" v-model="formValues">
          <formulate-input :help="'Kolommen: Omschrijving, Bestelnr, Poederlak, Natlak'" :uploader="uploader" :upload-url="uploadUrl" :file-upload-progress="uploadFile()" :file-upload-complete="uploadFileComplete()" error-behavior="submit" name="file" type="file" upload-behavior="submit" label="Upload het poederlijst import bestand hier" validation="mime:text/csv"></formulate-input>
          <formulate-input input-class="btn" type="submit" :label="isLoading ? 'Even geduld...' : 'Bestand uploaden'"></formulate-input>
        </formulate-form>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiService } from '@/services/admin/api.service'
import PageTitle from '@/components/admin/PageTitle'
import { notification } from '@/notifications'

export default {
  components: { PageTitle },
  data: function () {
    return {
      isLoading: true,
      uploadUrl: '/powderlist',
      fileData: null,
      formValues: {},
      uploading: false,
      uploader: ApiService.getAxiosInstance()
    }
  },
  async mounted () {
    this.isLoading = false
  },
  methods: {
    uploadFile: async function () {
      if (this.formValues.file !== undefined) {
        this.uploading = true
      }
    },
    uploadFileComplete: async function () {
      this.uploading = false
      this.isLoading = false
    },
    submitForm: async function () {
      this.isLoading = true
      await ApiService.uploadPowderlist(this.formValues).then((res) => {
        if (res.status === 200) {
          this.fileData = null
          notification('Poederlijst succesvol geïmporteerd!')
          this.isLoading = false
        }
      })
    }
  }
}
</script>
